import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CotHttp } from './cot-http.service';
import { CustomHttpInterceptor } from './http-interceptor';
import { LogService } from './log-service';

/** CotHttpModule exports the classWeb COT http communication layer related services,classes & files **/

@NgModule({
    imports: [HttpClientModule],
    providers: [CotHttp, LogService, { provide: HTTP_INTERCEPTORS, useClass: CustomHttpInterceptor, multi: true }]
})

export class CotHttpModule { }



// WEBPACK FOOTER //
// ./src/app/http-communication/cot-http.module.ts